// Nivel de layout del wizard ("mobile" | "compact" | "wide") leído de --wizard-layout en el form, que
// el CSS decide por el ancho del contenedor. Doc: partner_product_form.md → "Shell responsive"
export function wizardLayout(element) {
  const form = element.closest(".product-wizard")?.querySelector(".product-wizard__form")
  if (!form) return "mobile"
  return getComputedStyle(form).getPropertyValue("--wizard-layout").trim() || "mobile"
}

// Sheets, editor a pantalla completa y modales solo en mobile; compact y wide usan popovers e inline
export function wizardMobile(element) {
  return wizardLayout(element) === "mobile"
}
